// extracted by mini-css-extract-plugin
module.exports = {"modal":"ConfirmationModal_modal__QIUDL","backdrop":"ConfirmationModal_backdrop__h4EYK"};